import axios, { AxiosError } from "axios";
import { UseQueryOptions } from "react-query";
import { config } from "../config";
import { useCollection } from "../hooks/useCollection";
import { authenticate, createResponseErrorHandler } from "./interceptors";

const queryParams = new URLSearchParams(location.search);
const tutorialUriParam = queryParams.get("tutorialApi");

export const tutorialsUri = tutorialUriParam ? tutorialUriParam : config.tutorials.url;
export const tutorialsApi = axios.create({ baseURL: `${tutorialsUri}/api/` });

tutorialsApi.interceptors.request.use(authenticate);
tutorialsApi.interceptors.response.use((response) => response, createResponseErrorHandler(tutorialsApi));

export const useTutorialCollection = <T>(
    path: string | string[],
    queryParams?: any,
    options?: UseQueryOptions<T, AxiosError, T[]>,
) => {
    const collectionOptions: any = { ...options, api: tutorialsApi };
    return useCollection<T>(path, queryParams, collectionOptions);
};
